import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=e487c67e&scoped=true&"
import script from "./videoComponent.vue?vue&type=script&lang=js&"
export * from "./videoComponent.vue?vue&type=script&lang=js&"
import style0 from "./videoComponent.vue?vue&type=style&index=0&id=e487c67e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e487c67e",
  null
  
)

export default component.exports